module.exports = __webpack_public_path__ + "img/empty.dbf7735a.png";